import { render, staticRenderFns } from "./ImportComponentsForm.vue?vue&type=template&id=f58d8a48&"
import script from "./ImportComponentsForm.js?vue&type=script&lang=js&"
export * from "./ImportComponentsForm.js?vue&type=script&lang=js&"
import style0 from "./ImportComponentsForm.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
